import React from "react";
import PropTypes from "prop-types";

import AppCircularProgress from "components/Progress/AppCircularProgress";
import ProgressStep from "./ProgressStep";

const ProgressProfile = (props) => {
  const {
    value,
    progress,
    step,
    handleBackStep,
    hideCircle,
    feedbacks = []
  } = props;

  const handleClick = (index) => {
    handleBackStep(index);
  };

  return (
    <div>
      {
        !hideCircle && (
          <div>
            <AppCircularProgress value={value} />
          </div>
        )
      }
      <div className="mt-3">
        {
          progress && progress.map((item, index) => (
            <ProgressStep
              onClick={() => handleClick(index)}
              checked={item.checked}
              active={step === index}
              invalid={feedbacks && feedbacks.filter(fb => fb.partType === item.code).length > 0}
              label={item.label}
              key={`step-${index}`}
            />
          ))
        }
      </div>
    </div >
  );
}

ProgressProfile.propTypes = {
  value: PropTypes.number,
  step: PropTypes.number,
  progress: PropTypes.array,
  handleBackStep: PropTypes.func,
  hideCircle: PropTypes.bool,
  feedbacks: PropTypes.any
};

export default ProgressProfile;
